export default __webpack_public_path__ + "static/media/screenshot2_sm.718a5ab9.jpg";